module.exports = __webpack_public_path__ + "img/facebook.e31ad522.svg";